module.exports = __webpack_public_path__ + "img/python-programming-language.b62fe705.png";